var _a, _b;
import { __assign } from "tslib";
import { handleActions, combineActions } from 'redux-actions';
import { reduxKey } from './constants';
import { initializeNetworkBar, markChannelAsRead, updateNetworkBarSection, setNetworkBarSection, } from './actions';
import { generateMainNavigation, getDefaultMainNavigation } from './helpers';
var handler = handleActions((_a = {},
    _a[initializeNetworkBar.toString()] = function (state, _a) {
        var mainNavNewContent = _a.payload.mainNavNewContent;
        return (__assign(__assign({}, state), { mainNavigation: generateMainNavigation(mainNavNewContent), isInitialized: true }));
    },
    _a[markChannelAsRead.toString()] = function (state, _a) {
        var channel = _a.payload.channel;
        // groups are handled by saga, this takes care of the main nav
        var navItem = state.mainNavigation.find(function (n) { return n.key === channel; });
        if (navItem === null || navItem === void 0 ? void 0 : navItem.hasNewContent) {
            return __assign(__assign({}, state), { mainNavigation: state.mainNavigation.map(function (n) {
                    return n === navItem ? __assign(__assign({}, n), { hasNewContent: false }) : n;
                }) });
        }
        return state;
    },
    _a[combineActions(updateNetworkBarSection, setNetworkBarSection).toString()] = function (state, _a) {
        var _b;
        var _c = _a.payload, section = _c.section, isFoldedNow = _c.isFoldedNow;
        return state.sections[section].isFolded === isFoldedNow
            ? state
            : __assign(__assign({}, state), { sections: __assign(__assign({}, state.sections), (_b = {}, _b[section] = { isFolded: isFoldedNow }, _b)) });
    },
    _a), {
    isInitialized: false,
    mainNavigation: getDefaultMainNavigation(),
    sections: {
        watched_groups: { isFolded: false },
        recommended_groups: { isFolded: false },
    },
});
export default (_b = {},
    _b[reduxKey] = handler,
    _b);
//# sourceMappingURL=reducer.js.map